import type { DeliveryOptionType } from "@store/slices/LEGACY__checkoutSlice/LEGACY__checkoutSlice.types";
import type { BillingAddressType } from "@store/types";

import type { ExternalShippingCarrier } from "@jti/commerce-types";
import type { Address, Contact, FlotiqInStoreDeliveryStore } from "@jti/fe-common";
import type { OrderAttributeValues } from "@jti/magento";

export type PhoneCode = {
  label: string;
  value: string;
};

export type EditPhone = {
  code: PhoneCode;
  phone: string;
  internationalPhone?: string;
};

export type CheckoutShippingStepData = {
  atHomeDeliveryShippingAddress: Address;
  shippingAddress: Address;
  shippingContact: Contact;
  billingAddress: Address;
  billingAddressType: BillingAddressType;
  orderAttributes?: OrderAttributeValues;
  deliveryOptionType: DeliveryOptionType;
  shippingMethodCode: string;
  shouldUseInStoreDeliveryBillingAddress: boolean;
  inStoreDeliveryStore: FlotiqInStoreDeliveryStore | null;
  externalShippingCarrier: ExternalShippingCarrier | null;
  shouldUseAccountContact: boolean;
  editPhone: EditPhone | null;
  _hiddenValues?: Record<string, string>;
};

export type CheckoutDeliveryStepData = {
  shippingMethodCode: string;
  orderAttributes?: OrderAttributeValues;
  orderId: string;
  entityId: string;
};

export type StandardCheckoutSteps = "shipping" | "delivery";

export type StandardCheckoutForm = {
  isReady: boolean;
  shippingStepData: CheckoutShippingStepData | null;
  deliveryStepData: CheckoutDeliveryStepData | null;
};
